import { render, staticRenderFns } from "./item_actions.vue?vue&type=template&id=f94c61e8&scoped=true&"
import script from "./item_actions.vue?vue&type=script&lang=js&"
export * from "./item_actions.vue?vue&type=script&lang=js&"
import style0 from "./item_actions.vue?vue&type=style&index=0&id=f94c61e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94c61e8",
  null
  
)

export default component.exports